// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__Itfap","icon_container":"style_icon_container__VpLwh","img-load":"style_img-load___YWnz"};